module.exports = __webpack_public_path__ + "img/icon_cate_new.15d7cc5e.svg";